module.exports = function() {
  return new Worker(__webpack_public_path__ + "2886ad57d23a491dc9af.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/components/worker/babel.worker.js
// module id = 419
// module chunks = 2